import React from "react";
import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Image as ImageIcon, DollarSign, User, Calendar, Gem, Mail, CreditCard } from "lucide-react";

const links = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/bio", label: "About / Bio", icon: User },
  { to: "/admin/rates", label: "Rates", icon: DollarSign },
  { to: "/admin/media", label: "Photos & Videos", icon: ImageIcon },
  { to: "/admin/tiers", label: "Memberships", icon: Gem },
  { to: "/admin/payments", label: "E-Transfers", icon: CreditCard },
  { to: "/admin/bookings", label: "Bookings", icon: Calendar },
  { to: "/admin/messages", label: "Messages", icon: Mail },
];

export default function AdminLayout() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user || user.role !== "admin") return <Navigate to="/login" replace state={{ redirect: "/admin" }} />;

  return (
    <div className="pt-28 pb-24 min-h-screen" data-testid="admin-layout">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 grid lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3 lg:sticky lg:top-28 lg:self-start">
          <div className="glass-panel rounded-md p-5">
            <div className="text-[10px] tracking-[0.3em] uppercase text-pink-blush mb-4">Admin Panel</div>
            <nav className="space-y-1">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-sm text-sm transition-all ${
                      isActive
                        ? "bg-pink-hot/15 text-pink-hot border border-pink-hot/30"
                        : "text-champagne/80 hover:bg-noir-surface hover:text-pink-blush"
                    }`
                  }
                >
                  <l.icon className="w-4 h-4" />
                  {l.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </aside>
        <main className="lg:col-span-9">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
